module.exports = __webpack_public_path__ + "static/media/BC13_CK.b95f4860.jpg";